module.exports = __webpack_public_path__ + "img/bowler.796d98be.svg";